var u;(function(o){o.halfAnHour="halfAnHour",o.oneHour="oneHour",o.twoHour="twoHour",o.fullNight="fullNight"})(u||(u={}));export{u as PriceType};
